import { css } from 'styled-components';

const avatarImageStyle = css`
.avatar-image {
  border: 1px solid ${(p) => p.theme.tableBorderColor};
  height: 110px;
  width: 110px;
  max-width: 110px;
}
`;

export default avatarImageStyle;
